import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { PreviewProcessComponent } from 'app/previewProcess/previewProcess.component';
import { PreviewProcessRoutingModule } from 'app/previewProcess/previewProcess-routing.module';
import { CeiboShareModule } from 'app/shared/ceiboShare/ceiboShare.module';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    BrowserModule,
    TranslateModule,
    MomentModule,
    CoreModule,
    SharedModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    PreviewProcessRoutingModule,
    CeiboShareModule
  ],
  declarations: [
    PreviewProcessComponent
  ],
  providers: [
    ProcessService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class PreviewProcessModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/previewProcess/previewProcess.module.ts